module.exports = __webpack_public_path__ + "0-es2015.90861f31b573e349eaa2.worker.js"